import { useLayoutEffect } from 'react'
import { Trans } from 'react-i18next'

import {
  historyIntroFiguresPNG,
  historyIntroFiguresWEBP,
} from '~/pages/history/intro/libs/components/History/constants'
import { HistoryIntroStyles as S } from '~/pages/history/intro/libs/components/History/styles'
import { eventLogger } from '~/shared/services/eventLogger'
import { appHistory } from '~/shared/utils'

interface IHistoryIntroProps {
  nextPagePath: string
}

const HEADER_BG = '#eeeef9'
const QUESTION = 'An intelligent person should know history'

const HistoryIntro = ({ nextPagePath }: IHistoryIntroProps) => {
  useLayoutEffect(() => {
    document.documentElement.style.setProperty('--header-bg', HEADER_BG)
    return () => {
      document.documentElement.style.removeProperty('--header-bg')
    }
  }, [])

  const handleContinue = () => {
    eventLogger.logFirstPageCompleted(QUESTION)
    eventLogger.logQuestion({
      question: QUESTION,
      pageName: 'intro-history-1',
    })
    appHistory.goTo(nextPagePath)
  }

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.Title>
          <Trans
            ns="history"
            i18nKey="onboarding.historyIntro.title"
            components={{ span: <span /> }}
          />
        </S.Title>

        <S.Subtitle>
          <Trans ns="history" i18nKey="onboarding.historyIntro.subtitle" />
        </S.Subtitle>

        <S.BottomSection>
          <picture>
            <source srcSet={historyIntroFiguresWEBP} type="image/webp" />
            <S.Image src={historyIntroFiguresPNG} alt="Historical figures" />
          </picture>

          <S.StyledButton type="button" onClick={handleContinue}>
            <Trans i18nKey="actions.continue" />
          </S.StyledButton>
        </S.BottomSection>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default HistoryIntro
